import { RefreshCw } from 'lucide-react';
import { useTranslation } from '@/shared/i18n/use-translation';
import { replica } from '@/shared/sync/replica';
import { usePendingCount } from '@/shared/sync/use-pending-count';
import { useSyncState } from '@/shared/sync/use-sync-state';
import { Button } from '@/shared/ui/button/button';
import { Card } from '@/shared/ui/card/card';
import { CardContent } from '@/shared/ui/card/card-content';
import { CardDescription } from '@/shared/ui/card/card-description';
import { CardHeader } from '@/shared/ui/card/card-header';
import { CardTitle } from '@/shared/ui/card/card-title';
import { describeSync } from '../helpers/describe-sync';
import { RejectionsNotice } from './rejections-notice';

export function SyncStatusCard() {
  const state = useSyncState();
  const { t } = useTranslation();
  const pending = usePendingCount() ?? 0;
  const { label, detail } = describeSync(state, pending);
  const syncing = state.status === 'syncing';
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('Sync')}</CardTitle>
        <CardDescription>
          {t('The server is the source of truth; this device keeps a full copy to work offline.')}
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="flex flex-col">
            <span className="font-medium">{label}</span>
            <span className="text-sm text-muted-foreground">{detail}</span>
          </div>
          <Button variant="outline" onClick={() => void replica.engine.syncNow()} disabled={syncing}>
            <RefreshCw className={syncing ? 'animate-spin' : undefined} /> {t('Sync now')}
          </Button>
        </div>
        <RejectionsNotice />
      </CardContent>
    </Card>
  );
}
